import { createElement, Fragment } from "react";
function jsxN2br(text) {
  const lines = text.split("\n");
  if (lines.length <= 1) {
    return text;
  }
  return lines.map((line, i) => /* @__PURE__ */ createElement(Fragment, {
    key: i
  }, !!i && /* @__PURE__ */ createElement("br", null), line));
}
function RenderLeafFallback({ leaf }) {
  let element = jsxN2br(leaf.text);
  if ("isCode" in leaf && leaf.isCode === true) {
    element = /* @__PURE__ */ createElement("code", null, element);
  }
  if ("isStruckThrough" in leaf && leaf.isStruckThrough === true) {
    element = /* @__PURE__ */ createElement("s", null, element);
  }
  if ("isHighlighted" in leaf && leaf.isHighlighted === true) {
    element = /* @__PURE__ */ createElement("em", null, element);
  }
  if ("isUnderlined" in leaf && leaf.isUnderlined === true) {
    element = /* @__PURE__ */ createElement("u", null, element);
  }
  if ("isItalic" in leaf && leaf.isItalic === true) {
    element = /* @__PURE__ */ createElement("i", null, element);
  }
  if ("isBold" in leaf && leaf.isBold === true) {
    element = /* @__PURE__ */ createElement("b", null, element);
  }
  return /* @__PURE__ */ createElement(Fragment, null, element);
}
export { RenderLeafFallback };
//# sourceMappingURL=RenderLeafFallback.js.map
